import { z } from 'zod';
import { messageDelivery, messageDeliveryStatus, messageTrigger } from './message-template.js';
import { paginatedResult, paginationQuery } from './common.js';
const date = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .refine(
    (value) =>
      !Number.isNaN(Date.parse(`${value}T00:00:00Z`)) &&
      new Date(`${value}T00:00:00Z`).toISOString().startsWith(value),
    'Choose a valid calendar date.'
  );
export const deliveryInspectionQuery = paginationQuery
  .extend({
    status: messageDeliveryStatus.optional(),
    trigger: messageTrigger.optional(),
    search: z.string().trim().max(100).optional(),
    from: date.optional(),
    to: date.optional(),
  })
  .refine(
    (value) => !value.from || !value.to || value.from <= value.to,
    'The end date must be on or after the start date.'
  );
export type DeliveryInspectionQuery = z.infer<typeof deliveryInspectionQuery>;
export const deliveryInspection = messageDelivery.omit({ externalNotificationId: true }).extend({
  channel: z.string().nullable(),
  notificationStatus: z.string().nullable(),
  attemptCount: z.number().int().nonnegative().nullable(),
  nextAttemptAt: z.string().nullable(),
  sentAt: z.string().nullable(),
  readAt: z.string().nullable(),
  failureNotice: z.string().nullable(),
});
export type DeliveryInspection = z.infer<typeof deliveryInspection>;
export const deliveryInspectionPage = paginatedResult(deliveryInspection);
